import { useParams } from 'react-router-dom';
import HTMLReport from '../../Reporting/HTMLReport';

export default function LotProcessDataReport() {
    const { lotNumber } = useParams();

    let url = `api/v1/lot/${lotNumber}/lotprocessdatareport`;
    let downloadName = `${lotNumber}-process-data-report.html`;

    return (
        <HTMLReport url={url} downloadName={downloadName} fullWidth={true}></HTMLReport>
    );
}